import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const FEATURES = ['6 Tomos de Reiki', '3 Bonos exclusivos', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'];
export function PricingSection() {
  return <section id="pricing" className="bg-gray-900 text-white py-20 md:py-28 px-4" data-id="element-168">
      <div className="container mx-auto max-w-2xl" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gray-800/50 rounded-3xl p-8 md:p-12 border border-gray-700 text-center" data-id="element-170">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-10" data-id="element-171">
            📦 Lo que recibís hoy
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-md mx-auto mb-12" data-id="element-172">
            {FEATURES.map((feature, idx) => <div key={idx} className="flex items-center gap-3 text-left" data-id="element-173">
                <div className="bg-green-500/20 p-1 rounded-full flex-shrink-0" data-id="element-174">
                  <Check className="w-4 h-4 text-green-400" strokeWidth={3} data-id="element-175" />
                </div>
                <span className="text-gray-300 font-medium" data-id="element-176">{feature}</span>
              </div>)}
          </div>

          <div className="mb-10" data-id="element-177">
            <p className="text-gray-500 text-base line-through decoration-red-500 decoration-2 mb-3" data-id="element-178">
              Precio regular: ARS $49.990
            </p>
            <p className="text-amber-400 font-bold text-lg mb-1" data-id="element-179">🔥 HOY:</p>
            <p className="text-5xl md:text-7xl font-extrabold text-white leading-none mb-2" data-id="element-180">
              ARS $19.990
            </p>
            <p className="text-gray-500 text-sm" data-id="element-181">(Pagás en tu moneda local)</p>
          </div>

          <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-2 px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.5)] hover:shadow-[0_0_50px_rgba(245,158,11,0.7)] transition-all" data-id="element-182">
            👉 OBTENER MI MEGAPACK HOY
            <ArrowRight className="w-6 h-6" data-id="element-183" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}